
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/golf-bags-storages-services-near-me",
      function () {
        return require("private-next-pages/golf-bags-storages-services-near-me/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/golf-bags-storages-services-near-me"])
      });
    }
  